import React from "react";
import { Link } from "react-router-dom";
import { services, serviceAreas } from "../data/siteContent";

const year = new Date().getFullYear();

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img src="/logoNavbar.svg" alt="Fairview Container Management" />
          </Link>
          <p>
            Fairview Container Management provides container destuffing, lumper crews,
            palletizing, wrapping, and warehouse labor support for GTA and Southern
            Ontario logistics teams.
          </p>
        </div>

        <div className="footer-links">
          <div>
            <h2>Site</h2>
            <Link to="/">Home</Link>
            <Link to="/services">Services</Link>
            <Link to="/industries">Industries</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div>
            <h2>Services</h2>
            {services.map((service) => (
              <Link key={service.slug} to={`/services#${service.slug}`}>
                {service.title}
              </Link>
            ))}
          </div>

          <div>
            <h2>Coverage</h2>
            {serviceAreas.slice(0, 6).map((area) => (
              <span key={area}>{area}</span>
            ))}
          </div>

          <div>
            <h2>Connect</h2>
            <a href="mailto:quotes@fairviewcm.ca">quotes@fairviewcm.ca</a>
            <Link to="/quote">Request a Quote</Link>
            <span>fairviewcm.ca</span>
            <span>fairviewcm.com</span>
            <span>GTA and Southern Ontario</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>&copy; {year} Fairview Container Management. All rights reserved.</span>
        <div>
          <Link to="/services">Services</Link>
          <Link to="/quote">Quote</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </div>
    </footer>
  );
}
